import { WAREHOUSES_ACTIONS, initialWarehousesState } from './warehouses.types'

/**
 * @param {import('./warehouses.types').WarehousesSlice} state
 * @param {Object} action
 */
export function warehousesReducer(state = initialWarehousesState, { type, payload }) {
  switch (type) {
    case WAREHOUSES_ACTIONS.SET_WAREHOUSES:
      return { ...state, data: payload }

    case WAREHOUSES_ACTIONS.SET_WAREHOUSE:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.id]: payload
        }
      }

    case WAREHOUSES_ACTIONS.SET_STATUS:
      return { ...state, status: payload }

    case WAREHOUSES_ACTIONS.SET_ERRORS:
      return { ...state, errors: [payload, ...state.errors] }

    case WAREHOUSES_ACTIONS.CLEAR_ERRORS:
      return { ...state, errors: [] }

    default:
      return state
  }
}
